const Home = () => {
    return (
      <div>
        <h3>🎉 USPACE 회원가입을 축하합니다 🎉</h3>
        <br></br>
        <a href="/login" className="radius8 lightBg" style={{ padding: "10px 15px" }}>
                이제 로그인하러 가볼까요?
        </a>
      </div>
    );
  };
  
export default Home;